export const tick = {
  tick: {
    shape:
      '<path d="M16.6673 5.73486L7.50065 14.9015L3.33398 10.7349" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
  },
};
